import { IUserProps } from '@/entities/User'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IUserState {
  response: IResponseProps<IUserProps>
  current: IUserProps | null
  scrollTop: number
  filter: string
}

export const state = (): IUserState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  scrollTop: 0,
  filter: 'all'
})

export default state
